import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	isBefore,
	subMonths,
	addMonths,
	addWeeks,
	startOfMonth,
	endOfMonth,
	startOfWeek,
	endOfWeek,
	format,
} from 'date-fns';
import CalendarWeek from './CalendarWeek';
import CalendarHeader from './CalendarHeader';

class Calendar extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			calendarStart: props.selectedDate || props.today,
		};
	}

	previousMonth = () => {
		this.setState((prevState) => ({
			calendarStart: subMonths(prevState.calendarStart, 1),
		}));
	};

	nextMonth = () => {
		this.setState((prevState) => ({
			calendarStart: addMonths(prevState.calendarStart, 1),
		}));
	};

	renderWeeks() {
		const {
			allValid,
			reservationWindow,
			closures,
			onDateClick,
			selectedDate,
			today,
		} = this.props;
		const { calendarStart } = this.state;

		const weekStart = startOfWeek(startOfMonth(calendarStart));
		const lastDate = endOfWeek(endOfMonth(calendarStart));
		const weeks = [];

		let currentWeekStart = weekStart;
		while (isBefore(currentWeekStart, lastDate)) {
			weeks.push(
				<CalendarWeek
					key={format(currentWeekStart, 'yyMMdd')}
					start={currentWeekStart}
					resWindow={reservationWindow}
					closures={closures}
					onDateClick={onDateClick}
					currentMonth={startOfMonth(calendarStart)}
					selectedDate={selectedDate}
					allValid={allValid}
					today={today}
				/>
			);
			currentWeekStart = addWeeks(currentWeekStart, 1);
		}

		return weeks;
	}

	render() {
		const { className, today, allValid, children } = this.props;
		const { calendarStart } = this.state;

		return (
			<div className={className}>
				<CalendarHeader
					month={calendarStart}
					onPreviousClick={this.previousMonth}
					onNextClick={this.nextMonth}
					today={today}
					allValid={allValid}
				/>
				<table className="calendar-body">
					<thead>
						<tr className="calendar-week">
							<th key="sun">Su</th>
							<th key="mon">Mo</th>
							<th key="tue">Tu</th>
							<th key="wed">We</th>
							<th key="thu">Th</th>
							<th key="fri">Fr</th>
							<th key="sat">Sa</th>
						</tr>
					</thead>
					<tbody>{this.renderWeeks()}</tbody>
				</table>
				{children}
			</div>
		);
	}
}

Calendar.propTypes = {
	today: PropTypes.instanceOf(Date),
	selectedDate: PropTypes.instanceOf(Date),
	closures: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
	reservationWindow: PropTypes.instanceOf(Date),
	onDateClick: PropTypes.func,
	className: PropTypes.string,
	children: PropTypes.node,
	allValid: PropTypes.bool,
};

Calendar.defaultProps = {
	today: new Date(),
	closures: [],
	allValid: false,
};

export default Calendar;
